export const MAX_YOUNGSTER_AGE = 27;
export const CHANNEL_ID = 30;
export const RECAPTCHA_DEV_KEY = "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI";
export const IS_TESTEABLE = process.env.REACT_APP_TESTEABLE === "true";
export const MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN;
export const APP_VERSION = process.env.REACT_APP_VERSION;
